'use strict';

/** Import location handler class */
import LocationHandler from '../location_handler/location_handler';

/** @const APP_SEARCH */
const APP_SEARCH = 'search';

/**
 * @class FilterLinks
 */
class FilterLinks
{
    /**
     * @return {{kategorija: Array, sezona: Array, proizvođač: Array, širina: Array, visina: Array, prečnik: Array, offset: Array, raspon: Array, centralna_rupa: Array}}
     */
    getFiltersCollectionFromLink ()
    {
        let filterCollection = this.constructor._getEmptyFiltersObj(),
            filtersArray = this._getFiltersArray();

        if (filtersArray.length > 0)
        {
            $.each(filtersArray, (k, v) =>
            {
                if (k > 0)
                {
                    let subFilters = v.split('+');
                    $.each (subFilters, (a, b) =>
                    {
                        let filterData = b.split('-');
                        filterCollection[filterData[0]].push(filterData[1]);
                    })
                }
            })
        }
        return filterCollection;
    }

    /**
     * @param filterCollection
     * @param page
     */
    generateLinkFromFilters (filterCollection, page)
    {
        let data = '',
            base = LocationHandler.getBaseUrl() + '/' + page;

        $.each(filterCollection, (k, v) =>
        {
            if (v.length > 0)
            {
                data += '/';
                $.each(v, (a, b) =>
                {
                    data += k + '-' + b + '+';
                });
                data = data.slice(0, -1);
            }
        });
        window.history.pushState('filters', 'filters', base + data);
    }

    /**
     * @return {Array}
     * @private
     */
    _getFiltersArray ()
    {
        let filters = [],
            current  = this.constructor._getCurrentLink(),
            parts = current.split(APP_SEARCH);

        if (parts.length > 1)
        {
            filters = parts[1].split('/');
        }
        return filters;
    }

    /**
     * @return {string}
     * @private
     */
    static _getCurrentLink ()
    {
        let current  = decodeURI(LocationHandler.getCurrentLocation());
        if (current.indexOf('#') >= 0)
        {
            current = current.slice(0, -1);
        }
        return current;
    }

    /**
     * @return {{kategorija: Array, sezona: Array, proizvođač: Array, širina: Array, visina: Array, prečnik: Array, offset: Array, raspon: Array, centralna_rupa: Array}}
     * @private
     */
    static _getEmptyFiltersObj ()
    {
        return {
            kategorija: [],
            sezona: [],
            proizvođač: [],
            širina: [],
            visina: [],
            prečnik: [],
            offset: [],
            raspon: [],
            centralna_rupa: [],
        }
    }
}

/** @export FilterLinks */
export default new FilterLinks();



// WEBPACK FOOTER //
// ./assets/js/shared/utility/filter_links/filter_links.js